import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/streams.js';
import programsMarkupList from '../markup2/universalListOfDataBody.js';
import toolsMarkup from '../markup/tools.js';
import cropWrap from '../tools/cropWrapper.js';
import tools from '../tools/tools.js';


const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);


const cardStream = document.querySelector('#FestStreamView');
const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_one_source');
const cardStreamName = cardStream.querySelector('input[name=nameStream]');
const cardStreamLink = cardStream.querySelector('textarea[name=link]');
const cardStreamMaxView = cardStream.querySelector('select[name=countMaxView]');


const timeEndDaySelector = cardStream.querySelector('select[name=time_end_day_month]');
const timeEndHourSelector = cardStream.querySelector('select[name=time_end_hour]');
const timeEndMinSelector = cardStream.querySelector('select[name=time_end_min]');

const cardStreamAddChange = cardStream.querySelector('button[name=enterBT]');
const cardStreamAddDelete = cardStream.querySelector('button[name=delete]');


const selectTimeZone = document.querySelector('#FestStreams').querySelector('select[name=listTimeZone]');

// const cardStreamUploadNewImage = document.querySelector('#Arbitors_card_image-uploader');
// const cardStreamUploadNewImageElem = document.querySelector('#Arbitors_card_image-uploader-Elem');

const menuBt =  document.querySelector('#MenuStreams');
let currentStream;

const mainTabPane = document.querySelector('#FestStreams');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const mainStreamLink = mainTabPane.querySelector('.streamInfo').querySelector('textarea');
const mainStreamOn = mainTabPane.querySelector('.streamInfo').querySelector('input[name=streamOn]');
const mainStreamSaveBT = mainTabPane.querySelector('.streamInfo').querySelector('button[name=mainStreamSaveBT]');



const mainTabPaneBTDataDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTDataSort = mainTabPane.querySelector('button[name=typeDataSort]');

let typeDataDisplay = 0;

mainTabPaneBTDataDisplay.addEventListener('click', function () {
  // 0 - список
  // 1 - иконки
  // alert();
  let typeDataDisplay = mainTabPaneBTDataDisplay.value;
  mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 1)
    typeDataDisplay = -1;

  mainTabPaneBTDataDisplay.value = typeDataDisplay;
  mainTabPaneBTDataDisplay.classList.add(`iconDataDisplay${typeDataDisplay}`);
  
  reDisplayMainTable();
});




const onSaveComplite = (answer) => {
  getPoints();
  // console.log(answer);
  if(answer && answer.data) {
    currentStream = parseInt(answer.data);
    cardStream.setAttribute('currentStream', currentStream);
  }

  cardPhotoSpinner.style.opacity = 0;
};


function forEach(data, callback) {
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      callback(key, data[key]);
    }
  }
}



mainTabPaneBTReload.addEventListener('click', function () {
  getPoints();
});

cardStreamAddDelete.addEventListener('click', function () {
  if(confirm('Вы точно хотите удалить данный блок??? \nБлок будет удален с сервера, если его нет в расписании и его нет в истории просмотров у других пользователей.')){
    xhr.request = {
      metod: 'DELETE',
      url: `streams/${currentStream}`,
      data: ``,
      callbackSuccess: onSuccessAddLoad
    };
  }
});

mainTabPaneBTAdd.addEventListener('click', function () {
   $(formAdd).modal('hide'); //Добавление жюри !!! перенести во внутрь секции!
    currentStream = -1;
    cardStream.setAttribute('currentStream', currentStream);
    cardStreamAddChange.innerHTML = 'Добавить';
    clearCard();
    $(cardStream).modal('show');
});

cardStreamAddChange.addEventListener('click', function (evt) {
  evt.preventDefault();

    let selectedEndDay = timeEndDaySelector.options[timeEndDaySelector.selectedIndex];
    let eMonth = parseInt(selectedEndDay.getAttribute('month'), 10) + 1;
    let eDay = selectedEndDay.value;
    let eHour = timeEndHourSelector.value;
    eHour -= selectTimeZone.value;

    if(eHour < 0){
      eHour += 24;
      eDay -=1;
    } else if(eHour > 23){
      
      eHour -= 24;
      eDay +=1;
    }

  // проверка смещения по месяцу!!!!

    let timeEnd = `${selectedEndDay.getAttribute('year')}-${tools.addZeroBefore(eMonth)}-${tools.addZeroBefore(eDay)} ${eHour}:${timeEndMinSelector.value}:00`;
 



  if (cardStream.getAttribute('currentStream') > 0) {
    // console.log(cardStream.getAttribute('currentStream'));
    if(confirm('Вы уверены, что хотите внести изменения?'))
      xhr.request = {
        metod: 'PUT',
        url: `streams/${cardStream.getAttribute('currentStream')}/`,
        data: `name=${cardStreamName.value}&link=${encodeURIComponent(cardStreamLink.value)}&timeEnd=${timeEnd}&maxView=${cardStreamMaxView.value}`,
        callbackSuccess: onSuccessAddLoad
      };

  } else {
    // пока без фото

    if(confirm('Вы уверены, что хотите создать запись?'))
      xhr.request = {
        metod: 'POST',
        url: `streams/`,
        data: `name=${cardStreamName.value}&link=${encodeURIComponent(cardStreamLink.value)}&timeEnd=${timeEnd}&maxView=${cardStreamMaxView.value}`,
        callbackSuccess: onSuccessAddLoad
      };
  }

});
mainStreamSaveBT.addEventListener('click', function(evt){
  if(confirm('Изменить сслыку на прямую трансляцию?'))
      xhr.request = {
        metod: 'PUT',
        url: `streams/0/`,
        data: `link=${mainStreamLink.value}`,
        callbackSuccess: onSuccessAddLoad
      };
  
});

mainStreamOn.addEventListener('change', function (evt) {
  console.log('click');
  let timeEnd = '';
  let confirmTXT = '';

  if(mainStreamOn.checked){
    let selectedEndDay = timeEndDaySelector.options[timeEndDaySelector.options.length - 1];
    let eMonth = parseInt(selectedEndDay.getAttribute('month'), 10) + 1;
    let eDay = selectedEndDay.value;
    let eHour = timeEndHourSelector.value;
    eHour -= selectTimeZone.value;

    if(eHour < 0){
      eHour += 24;
      eDay -=1;
    } else if(eHour > 23){
      
      eHour -= 24;
      eDay +=1;
    }

  // проверка смещения по месяцу!!!!
    confirmTXT = 'Вы уверены, что хотите включить прямую трансляцию?';
    timeEnd = `${selectedEndDay.getAttribute('year')}-${tools.addZeroBefore(eMonth)}-${tools.addZeroBefore(eDay)} ${eHour}:${timeEndMinSelector.value}:00`;
  } else {
    confirmTXT = 'Вы уверены, что хотите отключить прямую трансляцию?';
    timeEnd = '2022-03-13 21:00:00';
  }

  if(confirm(confirmTXT))
    xhr.request = {
      metod: 'PUT',
      url: `streams/0/`,
      data: `timeEnd=${timeEnd}`,
      callbackSuccess: onSuccessAddLoad
    };


});

mainTabPaneBody.addEventListener('click', function (evt) {

  if(evt.target.attributes.action){
    evt.preventDefault();
    let action = evt.target.attributes.action.nodeValue;
    if(action === 'delete') {
      // if(confirm('Вы точно хотите удалить секцию:\n"' + evt.target.attributes.catName.nodeValue + '" ?' ))
        // xhr.request = {
        //   metod: 'DELETE',
        //   url: `juryCategories/${evt.target.attributes.catId.nodeValue}`,
        //   data: ``,
        //   callbackSuccess: getPoints
        // };
    } else if (action === 'rename') {
      let newName = prompt('Укажите новое название:', evt.target.attributes.catName.nodeValue);
      if (newName) {
        // xhr.request = {
        //   metod: 'PUT',
        //   url: `juryCategories/${evt.target.attributes.catId.nodeValue}`,
        //   data: `name=${newName}&type=${action}`,
        //   callbackSuccess: getPoints
        // };
      }
    } else if (action === 'edit')

      editStream(evt);

  } else if(evt.target.attributes.streamid)
    editStream(evt);
  
});

function editStream(evt){
  currentStream = evt.target.attributes.streamid.nodeValue;
  cardStream.setAttribute('currentStream', currentStream);
  clearCard();
  allLoadedData.forEach((cElement) => {
    if(parseInt(cElement.id, 10) === parseInt(currentStream, 10)){
      cardStreamName.value = cElement.name;
      cardStreamLink.value = cElement.link;
      cardStreamMaxView.value = cElement.maxView;
      // timeEndDaySelector.value = parseInt(cElement.timeEnd.substr(8, 2), 10);
      // timeEndHourSelector.value = parseInt(cElement.timeEnd.substr(11, 2), 10);
      timeEndMinSelector.value = parseInt(cElement.timeEnd.substr(14, 2), 10);
      let hourWithTimeZone = parseInt(cElement.timeEnd.substr(11, 2), 10) + parseInt(selectTimeZone.value, 10);
      let dayWithTimeZone = parseInt(cElement.timeEnd.substr(8, 2), 10);


      if(hourWithTimeZone < 0){
        hourWithTimeZone +=24;
        dayWithTimeZone -=1;
      } else if(hourWithTimeZone > 23){
        hourWithTimeZone -=24;
        dayWithTimeZone +=1;
      }
      timeEndDaySelector.value = dayWithTimeZone;
      timeEndHourSelector.value = hourWithTimeZone;


      console.log(hourWithTimeZone);
      console.log(cElement.timeEnd);
    }
  });

  cardStreamAddChange.innerHTML = 'Изменить';
  $(cardStream).modal('show');
}

const onSuccessAddLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    getPoints();
    $(cardStream).modal('hide');

  }
};

function clearCard() {

  cardStreamName.value = '';
  cardStreamLink.value = '';
  cardStreamMaxView.value = 3;

}


const getPoints = () => {

  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    // url: `editor/operator/${auth.data.operatorId}/festival/${auth.data.currentFestival}/juryList`,
    url: `streams/all/list/`,
    data: ``,
    callbackSuccess: onSuccessPointsLoad
  };

};

function reloadCountersValues () {

  if (mainTabPane.classList.contains('show'))
    xhr.request = {
      metod: 'GET',
      // url: `editor/operator/${auth.data.operatorId}/festival/${auth.data.currentFestival}/juryList`,
      url: `streams/all/info/`,
      data: ``,
      callbackSuccess: (answer) => {
        console.log(answer);
        if(answer.data){
          mainTabPane.querySelector('b[name=mainStreamViewsNow]').innerHTML = answer.data.mainStreamViewsNow;
          mainTabPane.querySelector('small[name=detail]').innerHTML = `Кол-во подтвержденных просмотров: ${answer.data.views} <br>Кол-во запрошенных сессий: ${answer.data.tokens}`;
        }
        
        setTimeout(function() { reloadCountersValues(); }, 5000);
        }
    };
}


const onSuccessPointsLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200 && loadedPoints.data) {
    if(loadedPoints.data && loadedPoints.data.length > 0) {
      let mainStream = loadedPoints.data.shift();
      mainStreamLink.value = mainStream.link;
      mainStreamOn.disabled = false;


      let dateEndMainStream = tools.strToDate(mainStream.timeEnd);

      let nowDate = new Date();

      if(dateEndMainStream.getTime() > nowDate.getTime())
        mainStreamOn.checked = 1; 
      else
        mainStreamOn.checked = 0;

      // if(dateEndMainStream.getTime())
      allLoadedData = loadedPoints.data;
      reDisplayMainTable();
    } else {
      mainStreamLink.value = '';
      mainStreamOn.checked = false;
      mainStreamOn.disabled = true;
      allLoadedData = [];
      reDisplayMainTable();
    }
  } else {
    pointsMarkup.cleanContainer();
    pointsMarkup.drawMarkupInContainer(`<p>Данных на сервере не обнаруженно</p>`);

  }
};



let allLoadedData = false;
let startDay = false;
let endDay = false;


function reDisplayMainTable() {


  if (mainTabPaneBTDataDisplay.value == 0) 
    programsMarkupList.drawDataInContaineInDIV(allLoadedData, mainTabPaneBody, 'streamID');
  else
    pointsMarkup.drawDataInContainer(allLoadedData);

}
function initOnce() {
  // reloadCountersValues();

  setTimeout(function() { reloadCountersValues(); }, 1000);

  if(!startDay) {
    tools.removeOptions(selectTimeZone);
    for (let i = -11; i < 12; i++) {
      let opt = document.createElement('option');
      opt.value = i;
      
      if(i > 0)
        opt.innerHTML = '+'+i;
      else
        opt.innerHTML = i;
      
      if(i == 3){
        opt.innerHTML += ' (MOSCOW)';
        opt.selected = true;
      }

      selectTimeZone.appendChild(opt);   
    }

    tools.removeOptions(timeEndHourSelector);


    for (let i = 0; i < 24; i++) {
      let opt = document.createElement('option');
      opt.value = i;
      if (i < 10) 
        opt.innerHTML = '0' + i;
      else 
        opt.innerHTML = i;
      
      timeEndHourSelector.appendChild(opt);
    }


    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/scheduleInfo`,
      data: '',
      callbackSuccess: onSuccessFestInfo
    };
  } else
  getPoints();
}

const onSuccessFestInfo = (servarAnswer) => {
  if (servarAnswer.status === 200) {

    let i = 0;
    startDay = tools.strToDate(servarAnswer.data.tStart);
    endDay = tools.strToDate(servarAnswer.data.tEnd);
    selectTimeZone.value = servarAnswer.data.tTimeZone;

    let firstDay = new Date(startDay.getTime()); 
    const dayOfWeek = [ "вс", "пн", "вт", "ср", "чт", "пт", "сб"];
    
    do {
      let strTimeToDisplay = `${firstDay.getDate()} ${tools.getMonthBeforeNameX(firstDay.getMonth()+1)} (${dayOfWeek[firstDay.getDay()]})`;
      let opt = document.createElement('option');
      opt.value = firstDay.getDate();
      opt.setAttribute('month',firstDay.getMonth());
      opt.setAttribute('year',firstDay.getFullYear());
      opt.innerHTML = strTimeToDisplay;

      timeEndDaySelector.appendChild(opt);

        ++i;
      firstDay.setDate(firstDay.getDate() + 1);

      if(firstDay.getDate() == endDay.getDate() && firstDay.getMonth() ==  endDay.getMonth() && firstDay.getFullYear() == endDay.getFullYear())
        i = 25;
    } while(i < 30 );

    getPoints();
    // displayCalendarDays();
    // loadOneDay();   
  }

};




selectTimeZone.addEventListener('change', function () {
  reDisplayMainTable();
});


export default {

  start() {
    menuBt.addEventListener('click', initOnce);
    // menuBt.addEventListener('click', getPoints);
    // menuBt.addEventListener('click', initCard);
  },

  redraw: getPoints,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getPoints);
    // menuBt.removeEventListener('click', getPoints);
  }
};
